// hooks/useSuccess.ts
// Importa o componente de mensagens "message" da biblioteca Ant Design (antd),
// que será utilizado para exibir mensagens de sucesso na interface.
import { message } from "antd";

// Define o hook customizado `useSuccess` que será utilizado para exibir
// uma mensagem de sucesso no aplicativo.
export const useSuccess = () => {
  // Usa o hook `message.useMessage` do Ant Design, que retorna duas variáveis:
  // - `messageApi`: a API que permite abrir e controlar as mensagens.
  // - `contextHolder`: um elemento React que deve ser incluído no JSX para
  // permitir que as mensagens apareçam corretamente no layout.
  const [messageApi, contextHolder] = message.useMessage();

  // Função `showSuccess` que exibe uma mensagem de sucesso com o texto
  // passado como argumento.
  const showSuccess = (texto: string) => {
    messageApi.open({
      type: "success", // Define o tipo da mensagem como "success" (sucesso).
      content: texto, // Define o conteúdo da mensagem com o texto fornecido.
    });
  };

  // Retorna a função `showSuccess` para ser usada em outros componentes
  // e o `contextHolder` que deve ser renderizado na árvore de componentes.
  return { showSuccess, contextHolder };
};
